
import { defineComponent, onMounted } from "vue";

import FmAudio from "./components/FmAudio.vue";
import FmRead from "./components/FmRead.vue";

import useAudioPlay from "./hooks/useAudioPlay";

export default defineComponent({
  components: {
    FmAudio,
    FmRead,
  },

  setup() {
    const {
      changePlayStatus,
      onChangeCurrentTime,
      initAudioPlayer,
      currentTab,
      tabList,
      audioManager,
      audioDuration,
      audioCurrentTime,
      audioCurrentSlider,
      isPaused,
      audioDetail,
    } = useAudioPlay();

    onMounted(() => {
      initAudioPlayer();
    });

    return {
      changePlayStatus,
      onChangeCurrentTime,
      initAudioPlayer,
      currentTab,
      tabList,
      audioManager,
      audioDuration,
      audioCurrentTime,
      audioCurrentSlider,
      isPaused,
      audioDetail,
    };
  },
});
